import CursorSmoke from "./CursorSmoke";
import CursorPaint from "./CursorPaint";
import { useConfig } from "../../utils/config";

type CursorType = "rainbow" | "paint" | null;

interface CursorEffectProps {
    cursorType?: CursorType;
    colorMode: "dark" | "light";
}

const CursorEffect = ({ cursorType = "paint", colorMode }: CursorEffectProps) => {
    const config = useConfig();
    
    if (config.CURSOR_EFFECT && window.innerWidth > 768) {
        switch (cursorType) {
            case "rainbow":
                return <CursorSmoke />;
            case "paint":
                return <CursorPaint colorMode={colorMode} />;
            default:
                return null;
        }
    } else {
        return null;
    }
};

export default CursorEffect;
